module.exports = __webpack_public_path__ + "media/images/rate-great-c7deb5ef.png";